import React from "react";

/**
 * Lumiqo logo — LOCKED BRAND ASSET.
 * Renders the official uploaded PNG (with white background removed —
 * the logo strokes / colors / proportions are 100% preserved).
 *
 * No SVG recreation, no font substitution, no color override.
 *
 * Props:
 *   className: extra classes for sizing (use Tailwind `h-*` to control height).
 *              If omitted, falls back to a responsive default.
 *   alt:       accessible label, default "Lumiqo".
 */
const LOGO_SRC = "/lumiqo-logo-transparent.png";

export const LumiqoLogo = ({ className = "", alt = "Lumiqo" }) => (
  <img
    src={LOGO_SRC}
    alt={alt}
    draggable={false}
    className={`block w-auto select-none ${
      className || "h-10 sm:h-9"
    }`}
    style={{
      // crisp rendering for the small navbar size
      imageRendering: "auto",
    }}
    data-testid="lumiqo-logo"
  />
);

export default LumiqoLogo;
